export const APP_NAME = 'Typeflo'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const STOPWORDS = new Set([
    "the",
    "is",
    "in",
    "at",
    "of",
    "on",
    "and",
    "a",
    "to",
    "for",
    "with",
    "as",
    "by",
    "an",
    "be",
    "it",
    "or",
    "from",
    "that",
    "this",
    "are",
    "was",
    "but",
    "not",
    "have",
    "has",
    "had",
    "were",
    "which",
    "will",
    "would",
    "can",
    "could",
    "should",
    "may",
    "might",
    "do",
    "does",
    "did",
    "so",
    "if",
    "then",
    "than",
    "about",
    "into",
    "over",
    "after",
    "before",
    "such",
    "no",
    "yes",
    "all",
    "any",
    "each",
    "other",
    "more",
    "most",
    "some",
    "these",
    "those",
    "just",
    "like",
    "also",
    "how",
    "when",
    "where",
    "who",
    "what",
    "why",
    "whose",
    "while",
    "during",
    "between",
    "both",
    "because",
    "through",
    "up",
    "out",
    "off",
    "down",
    "under",
    "again",
    "further",
    "once",
    "here",
    "there",
    "their",
    "they",
    "them",
    "he",
    "she",
    "him",
    "her",
    "his",
    "its",
    "our",
    "us",
    "we",
    "you",
    "your",
    "yours",
    "my",
    "me",
    "mine",
    "i",
]);